import React from 'react';
import {ListItem, ListItemIcon, ListItemText, List, ListSubheader, MenuList } from "@material-ui/core";
import { useHistory } from 'react-router-dom';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import AssignmentLateIcon from "@material-ui/icons/AssignmentLate";
import WorkIcon from '@material-ui/icons/Work';

const profileSettings = [
    {
        text: "Προφιλ",
        href: "/dashboard/student/profile",
        index: 0,
        icon: <AccountCircleIcon />
    },
]

const itemList = [
    {
        text: "Η διατριβή μου",
        href: "/dashboard/student/thesis/current",
        index: 0,
        icon: <WorkIcon />
    },
    {
        text: "Ανοιχτές διατριβές",
        href: "/dashboard/student/theses/open",
        index: 1,
        icon: <AssignmentLateIcon />
    },
];

export default function StudentDesktopMenu() {
    const history = useHistory();

    return (

        <MenuList
            style={{
                borderRight:'1px solid #e0e0e0',
                maxHeight:'100vh',
                height: '100vh',
                backgroundColor: '#fff',
                paddingRight: '14px',
            }}
        >
            <List
                component="nav"
                aria-labelledby="nested-list-subheader"
                style={{position:'relative !important'}}
                subheader={
                    <ListSubheader component="div" id="nested-list-subheader">
                        Προφιλ
                    </ListSubheader>
                }
            >

                {
                    profileSettings.map( (item, index) => {
                        return (
                            <ListItem button key={index}>
                                <ListItemIcon>{item.icon}</ListItemIcon>
                                <ListItemText onClick={() => history.push(item.href)} primary={item.text} />
                            </ListItem>
                        )
                    })
                }
            </List>

            <List
                component="nav"
                aria-labelledby="nested-list-subheader"
                style={{position:'relative !important'}}
                title={
                    <ListSubheader component="div" id="nested-list-subheader">
                        Διατριβές
                    </ListSubheader>
                }
            >

                {
                    itemList.map( (item, index) => {
                        return (
                            <ListItem button key={index}>
                                <ListItemIcon>{item.icon}</ListItemIcon>
                                <ListItemText onClick={() => history.push(item.href)} primary={item.text} />
                            </ListItem>
                        )
                    })
                }
            </List>

        </MenuList>
    )
}